import React from 'react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { ToastProvider, ApiProvider, LayoutProvider } from '@shared/contexts';
import { AuthProvider, SignInProvider } from '@modules/users';

import { msalConfig } from './authConfig';
import ThemeProvider from './ThemeProvider';

const queryClient = new QueryClient();
/*
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 60 * 24, // 24 hours
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});
*/

const msalInstance = new PublicClientApplication(msalConfig);

const ProvidersWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <ToastProvider>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <ApiProvider>
              <SignInProvider>
                <DndProvider backend={HTML5Backend}>{children}</DndProvider>
              </SignInProvider>
            </ApiProvider>
          </AuthProvider>
        </MsalProvider>
      </ToastProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default ProvidersWrapper;
